import store from "@/store";
// import { InspectKbn, SeibiKbn } from "@/model/InspectKbn";
// import { InspectStaff } from "@/model/InspectStaff";
// import { LiftUse } from "@/model/LiftUse";
import { InspectionDetailState } from "@/store/modules/inspectionDetailStore";

const namespace = "InspectionDetail";

export class InspectionDetailStoreService {
  get currentState(): InspectionDetailState {
    return store.getters[`${namespace}/currentState`];
  }

  get effectiveMaxSeibishiHojoStaffCount(): number {
    return store.getters[`${namespace}/effectiveMaxSeibishiHojoStaffCount`];
  }

  // get inspectLine(): InspectKbn[] {
  //   return store.getters[`${namespace}/getInspectLine`];
  // }

  // get liftUse(): LiftUse[] {
  //   return store.getters[`${namespace}/getLiftUse`];
  // }

  // get shakenShurui(): SeibiKbn[] {
  //   return store.getters[`${namespace}/getShakenShurui`];
  // }

  // get staffHojo(): InspectStaff[] {
  //   return store.getters[`${namespace}/getStaffHojo`];
  // }

  // get staffKensain(): InspectStaff[] {
  //   return store.getters[`${namespace}/getStaffKensain`];
  // }

  // get staffSeibishi(): InspectStaff[] {
  //   return store.getters[`${namespace}/getStaffSeibishi`];
  // }

  // get useLine(): boolean {
  //   return store.getters[`${namespace}/useLine`];
  // }

  // get seibiMenuCd(): string {
  //   return store.getters[`${namespace}/seibiMenuCd`];
  // }

  // get jizen(): InspectKbn[] {
  //   return store.getters[`${namespace}/getJizen`];
  // }

  // get isDoJizen(): boolean {
  //   return store.getters[`${namespace}/isDoJizen`];
  // }

  // get shakenShuruiNm(): string {
  //   return store.getters[`${namespace}/getShakenShuruiNm`];
  // }

  // get shakenShuruiSeibiMenuUpdatedAt(): string {
  //   return store.getters[`${namespace}/getShakenShuruiSeibiMenuUpdatedAt`];
  // }

  // setInspectLine(payload: InspectKbn[]) {
  //   return store.dispatch(`${namespace}/setInspectLine`, payload);
  // }

  // setLiftUse(payload: LiftUse[]) {
  //   return store.dispatch(`${namespace}/setLiftUse`, payload);
  // }

  // setShakenShurui(payload: SeibiKbn[]) {
  //   return store.dispatch(`${namespace}/setShakenShurui`, payload);
  // }

  // setStaffHojo(payload: InspectStaff[]) {
  //   return store.dispatch(`${namespace}/setStaffHojo`, payload);
  // }

  // setStaffKensain(payload: InspectStaff[]) {
  //   return store.dispatch(`${namespace}/setStaffKensain`, payload);
  // }

  // setStaffSeibishi(payload: InspectStaff[]) {
  //   return store.dispatch(`${namespace}/setStaffSeibishi`, payload);
  // }

  save() {
    return store.dispatch(`${namespace}/save`);
  }

  setProgressState(payload: { stateId: number; stateNm: string }) {
    return store.dispatch(`${namespace}/setProgressState`, payload);
  }

  setMaxSeibishiHojoStaffCount(payload: number) {
    return store.dispatch(`${namespace}/setMaxSeibishiHojoStaffCount`, payload);
  }

  clearState() {
    return store.dispatch(`${namespace}/clearState`);
  }

  // setInspectLineCd(payload: string | number) {
  //   return store.dispatch(`${namespace}/setInspectLineCd`, payload);
  // }

  // setSeibiMenuCd(payload: string | number) {
  //   return store.dispatch(`${namespace}/setSeibiMenuCd`, payload);
  // }

  // setJizen(payload: InspectKbn[]) {
  //   return store.dispatch(`${namespace}/setJizen`, payload);
  // }

  // setJizenCd(payload: string | number) {
  //   return store.dispatch(`${namespace}/setJizenCd`, payload);
  // }

  // setShakenShuruiNm(payload: string) {
  //   return store.dispatch(`${namespace}/setShakenShuruiNm`, payload);
  // }

  // setShakenShuruiSeibiMenuUpdatedAt(payload: string) {
  //   return store.dispatch(`${namespace}/setShakenShuruiSeibiMenuUpdatedAt`, payload);
  // }
}
